import * as React from 'react';
import { ValidationLevel } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { manageOptionsButton } from 'app/area/shared/manage-options';
import { sfNames } from '../sf-names';
import { ExtraInfoFieldName } from './constants';
import { ExtraInfoItemProps } from './types';
import { getConfiguration } from './configuration';

import styles from './extra-info-item.scss';

export const ExtraInfoItem: React.FC<ExtraInfoItemProps> = ({
  formComponent: SimpleForm, readOnly, data, translation, validation, clearValidation, codeOptionsEndpoint, formOptions
}) => {

  const formConfig = getConfiguration(data.datatype).formConfiguration(data, translation);

  const validationMessages = validation?.[sfNames.additionalInformation]?.messages
    ?.filter(message => message?.parameters?.extraInfo === data.fieldId)
    ?.map(message => isDefinedIncludingZero(message.parameters?.valueCode)
      ? {
        ...message,
        parameters: {
          ...message.parameters,
          id: message.parameters.valueCode
        }
      }
      : message);

  const hasErrors = !!validationMessages && validationMessages.length > 0;

  const serverValidation = hasErrors
    ? { level: ValidationLevel.error, messages: validationMessages }
    : undefined;

  const clearServerValidation = (value: any) => {
    if (Array.isArray(value)) {

      validationMessages
        .filter(message => !value.some(v => v.value === message.parameters.id))
        .map(message => ({ extraInfo: data.fieldId, valueCode: message.parameters.id }))
        .forEach(parameters => clearValidation(sfNames.additionalInformation, parameters));
      return;
    }

    clearValidation(sfNames.additionalInformation, { extraInfo: data.fieldId });
  };

  const fieldName = ExtraInfoFieldName(data?.id);
  const rootId = formOptions?.options?.[fieldName]?.value;

  return <div className={`col-lg-4 col-sm-12 ${styles.field}`}>
    <SimpleForm
      {...formConfig}
      name={ExtraInfoFieldName(data.id)}
      label={{ text: data.fieldDesc }}
      readOnly={readOnly}
      translation={translation}
      optionsEndpoint={codeOptionsEndpoint(data.fieldId)}
      serverValidation={serverValidation}
      clearServerValidation={hasErrors ? clearServerValidation : undefined}
      extraFooterButton={manageOptionsButton(translation.manage_options, rootId)}
    />
  </div>;
};
